import { render, staticRenderFns } from "./FileEdit.vue?vue&type=template&id=06cbb983&scoped=true"
import script from "./FileEdit.vue?vue&type=script&lang=js"
export * from "./FileEdit.vue?vue&type=script&lang=js"
import style0 from "./FileEdit.vue?vue&type=style&index=0&id=06cbb983&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbb983",
  null
  
)

export default component.exports